/* Pokécado Binder (29.10.2026): Karten-Binder und Slabs-Binder auf Kollektionsseiten.
   Daten: sections/pc-binder.liquid (erste 250 Produkte) und templates/collection.binder-daten.liquid (weitere Pakete).
   Warenkorb-Knopf nur bei normalen Produkten (nie bei Captcha, Vorbestellung oder Verlosung); Kauflimiten prüft der Checkout. */
(function () {
  'use strict';
  if (window.PcBinder) return;

  /* Reihenfolge der Auswahlliste «Kartenseltenheit» (custom.seltenheit), Wert jeweils «Name (Kürzel)» */
  var RAR_ORDER = ['Common (C)', 'Uncommon (U)', 'Rare (R)', 'Double Rare (RR)', 'ACE SPEC Rare (ACE)', 'Ultra Rare Full Art (UR)', 'Ultra Rare Gold (UR)',
    'Illustration Rare (IR)', 'Special Illustration Rare (SIR)', 'Hyper Rare (HR)', 'Shiny Rare (S)', 'Shiny Ultra Rare (SSR)', 'Black White Rare (BWR)',
    'Mega Attack Rare (MA)', 'Mega Hyper Rare (MHR)', 'Futuristic Rare (FUR)', 'Classic Collection (CC)', 'Promo (PR)',
    'Super Rare (SR)', 'Art Rare (AR)', 'Special Art Rare (SAR)', 'Shiny Super Rare (SSR)', 'Mega Ultra Rare (MUR)',
    'Holo Rare (R)', 'Holo Rare V (V)', 'Holo Rare VMAX (VMAX)', 'Holo Rare VSTAR (VSTAR)', 'Secret Rare (SCR)', 'Trainer Gallery (TG)',
    'Radiant Rare (K)', 'Amazing Rare (A)', 'Triple Rare (RRR)', 'Character Rare (CHR)', 'Character Super Rare (CSR)'];
  var AREAS = ['ex star', 'Mega Evolution', 'Scarlet and Violet', 'Sword and Shield', ''];
  var ERA_COLOR = { 'ex star': '#C9A4D8', 'Mega Evolution': '#7BB5B2', 'Scarlet and Violet': '#7FA3CC', 'Sword and Shield': '#D6C08A', '': '#CFC7B4' };
  var PRICE = { karten: [[0, 5], [5, 20], [20, 50], [50, 1e9]], slabs: [[0, 50], [50, 100], [100, 250], [250, 1e9]] };
  var LANGS = ['EN', 'DE', 'FR', 'JP'];
  var GRADERS = ['PSA', 'BGS', 'CGC'];
  /* Was eine Kollektion schon einschränkt, gilt beim Querverweis in den anderen Binder mit */
  var IMPLIZIT = {
    'englische-singles': { lang: 'EN' }, 'deutsche-singles': { lang: 'DE' }, 'franzoesische-singles': { lang: 'FR' }, 'japanische-singles': { lang: 'JP' },
    'mega-evolution-singles': { era: 'Mega Evolution' }, 'scarlet-violet-singles': { era: 'Scarlet and Violet' }, 'aeltere-singles': { era: 'Sword and Shield' },
    'psa-graded-singles': { grader: 'PSA' }, 'bgs-graded-singles': { grader: 'BGS' },
    /* englische Adressen (übersetzte Handles für /en/) */
    'english-singles': { lang: 'EN' }, 'german-singles': { lang: 'DE' }, 'french-singles': { lang: 'FR' }, 'japanese-singles': { lang: 'JP' },
    'older-singles': { era: 'Sword and Shield' }
  };

  var I18N = {
    de: {
      search: 'Pokémon suchen', era: 'Ära', set: 'Set', lang: 'Sprache', rar: 'Seltenheit', grader: 'Grading', price: 'Preis', sort: 'Sortierung', all: 'Alle',
      reset: 'Filter zurücksetzen', clear: 'Suche leeren', pUpTo: 'bis CHF {b}', pRange: 'CHF {a} bis {b}', pFrom: 'ab CHF {a}',
      sSetNew: 'Set und Nummer, neue Sets zuerst', sSetOld: 'Set und Nummer, ältere Sets zuerst', sNew: 'Neu eingetroffen', sPa: 'Preis aufsteigend', sPd: 'Preis absteigend', sName: 'Name A bis Z',
      cards1: '1 Karte', cards: '{n} Karten', slabs1: '1 Slab', slabs: '{n} Slabs', pages1: '1 Seite', pages: '{n} Seiten', loading: 'weitere werden geladen',
      pageOf: 'Seite {a} von {n}', pagesOf: 'Seiten {a} und {b} von {n}', indexOf: 'Inhalt', prev: 'Vorherige Seite', next: 'Nächste Seite',
      jump: 'Gehe zu Seite', go: 'Los', filters: 'Filter', filtersT: 'Filter und Sortierung', done: 'Fertig', close: 'Schliessen',
      index: 'Inhalt', indexHint: 'Tippe auf ein Set, um direkt hinzublättern.', keys: 'Blättern: Wischen, Pfeiltasten oder Klick auf den Seitenrand. Karte antippen für die Grossansicht.',
      noSets: 'Die Register gibt es bei der Sortierung nach Set.',
      endKarten: 'Letzte Seite. Neue Karten ordnen wir laufend an der richtigen Stelle ein.', endSlabs: 'Letzte Seite. Neue Slabs ordnen wir laufend an der richtigen Stelle ein.',
      empty: 'Keine Karte passt zu deiner Auswahl.', emptyAll: 'In diesem Bereich sind gerade keine Karten. Neue Karten ordnen wir laufend ein.',
      toSlabs: 'Im Slabs-Binder ansehen ({n})', toKarten: 'Im Karten-Binder ansehen ({n})', allKarten: 'Ganzer Karten-Binder', allSlabs: 'Ganzer Slabs-Binder',
      EN: 'Englisch', DE: 'Deutsch', FR: 'Französisch', JP: 'Japanisch',
      areaEx: 'Pokémon ex★', areaME: 'Mega Evolution', areaSV: 'Scarlet & Violet', areaSWSH: 'Sword & Shield und älter', areaNone: 'Weitere Karten',
      front: 'Vorderseite', back: 'Rückseite', zin: 'Zum Vergrössern ins Bild tippen', zout: 'Zum Verkleinern nochmals tippen',
      cart: 'In den Warenkorb', inCart: 'Im Warenkorb', adding: 'Wird hinzugefügt …', product: 'Zur Produktseite', prevC: 'Vorherige Karte', nextC: 'Nächste Karte',
      setL: 'Set', num: 'Nummer', rarity: 'Seltenheit', cond: 'Zustand', grade: 'Note', cert: 'Zertifikat', certChk: 'bei PSA prüfen', lng: 'Sprache',
      noBuy: 'Diese Karte legst du auf der Produktseite in den Warenkorb.', photo: 'Foto folgt', phNote: 'Foto folgt.', phBack: 'Foto der Rückseite folgt.',
      cartErr: 'Das hat nicht geklappt. Bitte versuche es auf der Produktseite.', toast: '{name} liegt im Warenkorb.',
      coverKarten: 'Karten-Binder', coverSlabs: 'Slabs-Binder', motto: 'Von Sammlern für Sammler', coverCnt: '{c} auf {p}',
      region: 'Binder', registers: 'Register', liveP: 'Seite {a} von {n}', listKarten: 'Alle Karten als Liste', listSlabs: 'Alle Slabs als Liste'
    },
    en: {
      search: 'Search Pokémon', era: 'Era', set: 'Set', lang: 'Language', rar: 'Rarity', grader: 'Grading', price: 'Price', sort: 'Sort by', all: 'All',
      reset: 'Clear filters', clear: 'Clear search', pUpTo: 'up to CHF {b}', pRange: 'CHF {a} to {b}', pFrom: 'CHF {a} and over',
      sSetNew: 'Set and number, newest sets first', sSetOld: 'Set and number, oldest sets first', sNew: 'New arrivals', sPa: 'Price, low to high', sPd: 'Price, high to low', sName: 'Name, A to Z',
      cards1: '1 card', cards: '{n} cards', slabs1: '1 slab', slabs: '{n} slabs', pages1: '1 page', pages: '{n} pages', loading: 'loading more',
      pageOf: 'Page {a} of {n}', pagesOf: 'Pages {a} and {b} of {n}', indexOf: 'Contents', prev: 'Previous page', next: 'Next page',
      jump: 'Go to page', go: 'Go', filters: 'Filters', filtersT: 'Filters and sorting', done: 'Done', close: 'Close',
      index: 'Contents', indexHint: 'Tap a set to turn straight to it.', keys: 'Turn the pages by swiping, with the arrow keys or by clicking the edge of a page. Tap a card to see it up close.',
      noSets: 'Dividers appear when sorting by set.',
      endKarten: 'Last page. We add new cards in the right place as they arrive.', endSlabs: 'Last page. We add new slabs in the right place as they arrive.',
      empty: 'No cards match your selection.', emptyAll: 'There are no cards in this section right now. We add new cards as they arrive.',
      toSlabs: 'View in the slab binder ({n})', toKarten: 'View in the card binder ({n})', allKarten: 'Whole card binder', allSlabs: 'Whole slab binder',
      EN: 'English', DE: 'German', FR: 'French', JP: 'Japanese',
      areaEx: 'Pokémon ex★', areaME: 'Mega Evolution', areaSV: 'Scarlet & Violet', areaSWSH: 'Sword & Shield and older', areaNone: 'Other cards',
      front: 'Front', back: 'Back', zin: 'Tap the image to zoom in', zout: 'Tap again to zoom out',
      cart: 'Add to basket', inCart: 'In your basket', adding: 'Adding …', product: 'View product page', prevC: 'Previous card', nextC: 'Next card',
      setL: 'Set', num: 'Number', rarity: 'Rarity', cond: 'Condition', grade: 'Grade', cert: 'Certificate', certChk: 'check with PSA', lng: 'Language',
      noBuy: 'You can add this card to your basket on the product page.', photo: 'Photo to follow', phNote: 'Photo to follow.', phBack: 'Photo of the back to follow.',
      cartErr: 'That did not work. Please try on the product page.', toast: '{name} is in your basket.',
      coverKarten: 'Card binder', coverSlabs: 'Slab binder', motto: 'From collectors, for collectors', coverCnt: '{c} on {p}',
      region: 'Binder', registers: 'Dividers', liveP: 'Page {a} of {n}', listKarten: 'All cards as a list', listSlabs: 'All slabs as a list'
    }
  };
  var AREA_KEY = { 'ex star': 'areaEx', 'Mega Evolution': 'areaME', 'Scarlet and Violet': 'areaSV', 'Sword and Shield': 'areaSWSH', '': 'areaNone' };

  function areaOf(era) {
    if (!era) return '';
    if (era === 'Mega Evolution' || era === '30th Celebration') return 'Mega Evolution';
    if (era === 'Scarlet and Violet' || era === 'ex star') return era;
    return 'Sword and Shield';
  }
  function abbr(v) { var m = /\(([^()]+)\)\s*$/.exec(v || ''); return m ? m[1] : (v || ''); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function numVal(n) { var m = String(n || '').match(/\d+/); return m ? parseInt(m[0], 10) : 0; }
  var idle = window.requestIdleCallback ? function (fn) { return requestIdleCallback(fn, { timeout: 500 }); } : function (fn) { return setTimeout(function () { fn(null); }, 80); };

  function create(root) {
    var LANG = root.dataset.lang === 'en' ? 'en' : 'de';
    var MODE = root.dataset.modus === 'slabs' ? 'slabs' : 'karten';
    var PER = MODE === 'slabs' ? 4 : 9;
    var HANDLE = root.dataset.handle || '';
    function t(k, v) {
      var s = I18N[LANG][k] != null ? I18N[LANG][k] : (I18N.de[k] != null ? I18N.de[k] : k);
      if (v) Object.keys(v).forEach(function (key) { s = s.split('{' + key + '}').join(v[key]); });
      return s;
    }
    function $(s) { return root.querySelector(s); }
    function $$(s) { return Array.prototype.slice.call(root.querySelectorAll(s)); }
    var fmtPrice = function (p) { return 'CHF ' + Number(p).toFixed(2); };
    function areaLabel(a) { return t(AREA_KEY[a] || 'areaNone'); }

    function defF() { return { q: '', era: '', set: '', lang: '', rar: '', grader: '', price: '', sort: root.dataset.sort === 'created-descending' ? 'new' : 'set-new' }; }
    var S = { all: [], list: [], pages: [], N: 0, starts: [], p: 1, anim: null, closed: false, f: defF(), pick: null, lvIndex: -1, lvSide: 'front', W: 400, H: 610, tabw: 150,
      cart: {}, loading: false, cross: null, crossBusy: false };

    /* ---------------- Daten ---------------- */
    function norm(x) {
      if (!x || !x.a) return null;
      var kind = x.k === 'graded' ? 'graded' : (x.k === 'raw' ? 'raw' : '');
      if (MODE === 'slabs' ? kind !== 'graded' : kind !== 'raw') return null;
      var nm = String(x.no || '').trim(), num = nm, total = '';
      var m = nm.match(/^#?\s*([A-Za-z]*\d+[A-Za-z]*)\s*\/\s*([A-Za-z0-9]+)$/);
      if (m) { num = m[1]; total = m[2]; }
      else { num = nm.replace(/^[A-Za-z]+\s+/, ''); total = (x.st != null && x.st !== '') ? String(x.st) : ''; if (/^\d+$/.test(total) && total.length < 3) total = ('00' + total).slice(-3); }
      var code = x.s || x.sn || '';
      var grade = x.g || '';
      return {
        id: String(x.i), url: x.u, name: x.n || '', num: num, total: total, code: code, setName: x.sn || x.s || '', setDate: x.sd || '', jp: x.se === 'Japanisch',
        era: x.e || '', area: areaOf(x.e), kind: kind, rarity: x.r || '', cond: x.c || '', grade: grade, grader: (grade.split(' ')[0] || '').toUpperCase(), cert: x.z || '',
        lang: String(x.l || '').toUpperCase(), price: (x.p || 0) / 100, vid: x.v, buy: x.kb === 1, date: x.d || '',
        f: x.f || '', F: x.F || '', b: x.b || '', B: x.B || ''
      };
    }
    function addItems(items) {
      var seen = {};
      S.all.forEach(function (c) { seen[c.id] = 1; });
      (items || []).forEach(function (x) { var c = norm(x); if (c && !seen[c.id]) { S.all.push(c); seen[c.id] = 1; } });
    }
    function fetchData(url, page) {
      var sep = url.indexOf('?') >= 0 ? '&' : '?';
      return fetch(url + sep + 'view=binder-daten' + (page > 1 ? '&page=' + page : ''), { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (txt) { try { return JSON.parse(String(txt).trim()); } catch (e) { return null; } })
        .catch(function () { return null; });
    }
    function numTxt(c) { return c.total ? c.num + '/' + c.total : (c.code ? c.code + ' ' : '') + c.num; }
    function nounCount(n) { return MODE === 'slabs' ? (n === 1 ? t('slabs1') : t('slabs', { n: n })) : (n === 1 ? t('cards1') : t('cards', { n: n })); }

    /* ---------------- Filter und Sortierung ---------------- */
    function matches(c, f, skip) {
      var q = f.q.trim().toLowerCase();
      if (skip !== 'era' && f.era && c.area !== f.era) return false;
      if (skip !== 'set' && f.set && c.code !== f.set) return false;
      if (skip !== 'lang' && f.lang && c.lang !== f.lang) return false;
      if (skip !== 'rar' && f.rar && c.rarity !== f.rar) return false;
      if (skip !== 'grader' && f.grader && c.grader !== f.grader) return false;
      if (skip !== 'price' && f.price) {
        var pr = PRICE[MODE][+f.price.slice(1) - 1];
        if (pr && !(c.price > pr[0] && c.price <= pr[1])) return false;
      }
      if (q) {
        var hay = (c.name + ' ' + c.setName + ' ' + c.code + ' ' + c.rarity + ' ' + c.grade).toLowerCase();
        if (hay.indexOf(q) < 0 && !(/^\d+$/.test(q) && numVal(c.num) === parseInt(q, 10))) return false;
      }
      return true;
    }
    function bySet(a, b, dir) {
      var da = a.setDate, db = b.setDate;
      return (dir * (da < db ? -1 : da > db ? 1 : 0)) || a.code.localeCompare(b.code) || numVal(a.num) - numVal(b.num) || a.num.localeCompare(b.num) || a.lang.localeCompare(b.lang) || a.name.localeCompare(b.name);
    }
    function sortList(L, s) {
      L.sort(s === 'set-old' ? function (a, b) { return bySet(a, b, 1); }
        : s === 'new' ? function (a, b) { return b.date.localeCompare(a.date) || bySet(a, b, -1); }
        : s === 'pa' ? function (a, b) { return a.price - b.price || bySet(a, b, -1); }
        : s === 'pd' ? function (a, b) { return b.price - a.price || bySet(a, b, -1); }
        : s === 'name' ? function (a, b) { return a.name.localeCompare(b.name) || bySet(a, b, -1); }
        : function (a, b) { return bySet(a, b, -1); });
      return L;
    }
    function recompute() {
      S.list = sortList(S.all.filter(function (c) { return matches(c, S.f); }), S.f.sort);
      S.pages = [];
      for (var i = 0; i < S.list.length; i += PER) S.pages.push(S.list.slice(i, i + PER));
      S.N = S.pages.length;
      S.starts = [];
      if (S.f.sort === 'set-new' || S.f.sort === 'set-old') {
        var prev = null;
        S.list.forEach(function (c, i) {
          if (c.code !== prev) { S.starts.push({ code: c.code, page: Math.floor(i / PER) + 1, era: c.area, name: c.setName || areaLabel(''), jp: c.jp, count: 0 }); prev = c.code; }
          S.starts[S.starts.length - 1].count++;
        });
      }
      pageCache.clear();
    }
    function activeCount() {
      var f = S.f, d = defF();
      return ['era', 'set', 'lang', 'rar', 'grader', 'price'].filter(function (k) { return f[k]; }).length + (f.q ? 1 : 0) + (f.sort !== d.sort ? 1 : 0);
    }

    /* ---------------- Platzhalter ---------------- */
    var phCache = {};
    function svgURI(svg) { return 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svg); }
    function placeholder(back) {
      var key = (back ? 'b' : 'f') + MODE;
      if (phCache[key]) return phCache[key];
      var slab = MODE === 'slabs', w = 630, h = slab ? 1040 : 880;
      var txt = back ? t('back') : t('photo');
      var svg = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ' + w + ' ' + h + '"><rect x="6" y="6" width="' + (w - 12) + '" height="' + (h - 12) + '" rx="' + (slab ? 26 : 30) + '" fill="#2F2F2B" stroke="#4A4A44" stroke-width="4"/>' +
        '<rect x="44" y="44" width="' + (w - 88) + '" height="' + (h - 88) + '" rx="16" fill="none" stroke="#EDD286" stroke-width="3" stroke-dasharray="12 12" opacity=".45"/>' +
        '<text x="' + (w / 2) + '" y="' + (h / 2 + 10) + '" text-anchor="middle" font-family="system-ui,Arial" font-size="34" font-weight="600" fill="#FFF4DD" opacity=".85">' + esc(txt) + '</text></svg>';
      phCache[key] = svgURI(svg);
      return phCache[key];
    }

    /* ---------------- Seiten ---------------- */
    var pageCache = new Map();
    function pocketHTML(c, idx) {
      var label = [abbr(c.rarity), c.lang, c.kind === 'raw' ? abbr(c.cond) : c.grade].filter(Boolean).join(' · ');
      var alt = [c.name + ' ' + numTxt(c), c.setName ? c.setName + (c.code && c.code !== c.setName ? ' (' + c.code + ')' : '') : '', c.rarity, t(c.lang), c.kind === 'raw' ? c.cond : c.grade].filter(Boolean).join(', ');
      var src = c.f || placeholder(false);
      return '<a class="pc-b-pocket" href="' + esc(c.url) + '" data-i="' + idx + '"><span class="pc-b-sleeve"><img src="' + esc(src) + '" alt="' + esc(alt) + '" decoding="async" draggable="false"></span>' +
        '<span class="pc-b-tag"><span class="pc-b-l1"><span>' + esc(c.name) + '</span><small>' + esc(numTxt(c)) + '</small></span><b>' + fmtPrice(c.price) + '</b><i>' + esc(label) + '</i></span></a>';
    }
    function makePage(p) {
      var el = document.createElement('div');
      el.dataset.p = p;
      var N = S.N;
      if (p === -1) { el.className = 'pc-b-page is-cover'; el.innerHTML = coverHTML(); return el; }
      if (p === 0) { el.className = 'pc-b-page is-index is-even' + (S.starts.length > 14 ? ' is-dense' : ''); el.innerHTML = indexHTML(); return el; }
      if (N === 0 && p === 1) { el.className = 'pc-b-page is-empty is-odd'; el.innerHTML = emptyHTML(); return el; }
      if (p >= 1 && p <= N) {
        var base = (p - 1) * PER, cards = S.pages[p - 1];
        var h = '<div class="pc-b-pockets' + (MODE === 'slabs' ? ' is-slabs' : '') + '">' + cards.map(function (c, j) { return pocketHTML(c, base + j); }).join('');
        for (var j = cards.length; j < PER; j++) h += '<span class="pc-b-pocket is-free" aria-hidden="true"><span class="pc-b-sleeve"></span></span>';
        el.className = 'pc-b-page ' + (p % 2 ? 'is-odd' : 'is-even');
        el.innerHTML = h + '</div><span class="pc-b-pno">' + p + '</span>';
        el.querySelectorAll('img').forEach(function (img) { img.addEventListener('error', onImgError); });
        fitLabels(el);
        return el;
      }
      if (p === N + 1 && N > 0) { el.className = 'pc-b-page is-end ' + (p % 2 ? 'is-odd' : 'is-even'); el.innerHTML = '<p>' + esc(t(MODE === 'slabs' ? 'endSlabs' : 'endKarten')) + '</p>'; return el; }
      el.className = 'pc-b-page is-blank';
      return el;
    }
    function onImgError(e) { var img = e.currentTarget; img.removeEventListener('error', onImgError); img.src = placeholder(false); }
    function pageEl(p) { if (!pageCache.has(p)) pageCache.set(p, makePage(p)); return pageCache.get(p); }
    var measureBox = document.createElement('div');
    measureBox.className = 'pc-b-measure';
    measureBox.setAttribute('aria-hidden', 'true');
    root.appendChild(measureBox);
    /* Zeile 1 (Name und Nummer): Schrift bis 9,5 px verkleinern, bevor der Name gekürzt wird */
    function fitLabels(el) {
      var lines = el.querySelectorAll('.pc-b-l1');
      if (!lines.length) return;
      var parent = el.parentNode, next = el.nextSibling;
      measureBox.appendChild(el);
      lines.forEach(function (l1) {
        l1.style.fontSize = '';
        var nm = l1.firstElementChild, size = parseFloat(getComputedStyle(l1).fontSize);
        while (nm.scrollWidth > nm.clientWidth + 0.5 && size > 9.5) { size -= 0.5; l1.style.fontSize = size + 'px'; }
      });
      if (parent) parent.insertBefore(el, next); else measureBox.removeChild(el);
    }
    function coverHTML() {
      var n = S.list.length, pp = Math.max(1, S.N);
      return '<div class="pc-b-frame"></div><div><span class="pc-b-cover-h">Pokécado<span class="pc-b-kana">ポケカード</span></span><span class="pc-b-sub">' + esc(t(MODE === 'slabs' ? 'coverSlabs' : 'coverKarten')) + '</span><span class="pc-b-cnt">' +
        esc(t('coverCnt', { c: nounCount(n), p: pp === 1 ? t('pages1') : t('pages', { n: pp }) })) + '</span></div><span class="pc-b-motto">' + esc(t('motto')) + '</span>';
    }
    function indexHTML() {
      var h = '<span class="pc-b-index-h">' + esc(t('index')) + '</span>';
      if (!S.starts.length) { h += '<span class="pc-b-hint">' + esc(S.N ? t('noSets') : (activeCount() ? t('empty') : t('emptyAll'))) + '</span>'; }
      else {
        h += '<span class="pc-b-hint">' + esc(t('indexHint')) + '</span>';
        var era = null, open = false;
        S.starts.forEach(function (s) {
          if (s.era !== era) { if (open) h += '</ol>'; era = s.era; h += '<span class="pc-b-era">' + esc(areaLabel(era)) + '</span><ol>'; open = true; }
          h += '<li><button type="button" data-jump="' + s.page + '" data-code="' + esc(s.code) + '"><i style="background:' + (ERA_COLOR[s.era] || ERA_COLOR['']) + '"></i><span>' + esc(s.name) + (s.jp ? ' (JP)' : '') +
            (s.code && s.code !== s.name ? ' <small>' + esc(s.code) + '</small>' : '') + '</span><b>' + s.page + '</b></button></li>';
        });
        if (open) h += '</ol>';
      }
      return h + '<span class="pc-b-keys">' + esc(t('keys')) + '</span>';
    }
    function emptyHTML() {
      var filtered = activeCount() > 0;
      var h = '<div><p>' + esc(filtered ? t('empty') : t('emptyAll')) + '</p>';
      if (filtered) h += '<button type="button" class="pc-b-ebtn" data-reset>' + esc(t('reset')) + '</button>';
      var ganz = root.dataset.ganzUrl, ganzH = root.dataset.ganzHandle;
      if (!filtered && ganz && ganzH && ganzH !== HANDLE) h += '<a class="pc-b-ebtn" href="' + esc(ganz) + '">' + esc(t(MODE === 'slabs' ? 'allSlabs' : 'allKarten')) + '</a>';
      if (S.cross && S.cross.n > 0) h += '<a class="pc-b-ebtn is-alt" href="' + esc(S.cross.href) + '">' + esc(t(MODE === 'slabs' ? 'toKarten' : 'toSlabs', { n: S.cross.n })) + '</a>';
      return h + '</div>';
    }
    function pruneCache() { pageCache.forEach(function (el, p) { if (!el.isConnected && Math.abs(p - S.p) > 6 && p > 0) pageCache.delete(p); }); }

    /* Leerer Binder: Treffer im anderen Binder anbieten (z.B. japanische Karten gibt es heute nur als Slabs) */
    function loadCross() {
      var url = root.dataset.gegenUrl;
      if (!url || S.crossBusy || S.cross) return;
      S.crossBusy = true;
      var imp = IMPLIZIT[HANDLE] || {};
      var keep = { era: S.f.era || imp.era || '', lang: S.f.lang || imp.lang || '', set: S.f.set || '', q: S.f.q || '' };
      fetchData(url, 1).then(function (d) {
        S.crossBusy = false;
        if (!d || !d.items) return;
        var otherKind = MODE === 'slabs' ? 'raw' : 'graded', q = keep.q.trim().toLowerCase();
        var n = d.items.filter(function (x) {
          if (!x.a || x.k !== otherKind) return false;
          if (keep.era && areaOf(x.e) !== keep.era) return false;
          if (keep.lang && String(x.l || '').toUpperCase() !== keep.lang) return false;
          if (keep.set && (x.s || x.sn) !== keep.set) return false;
          if (q && ((x.n || '') + ' ' + (x.sn || '') + ' ' + (x.s || '')).toLowerCase().indexOf(q) < 0) return false;
          return true;
        }).length;
        var parts = [];
        Object.keys(keep).forEach(function (k) { if (keep[k]) parts.push(k + ':' + encodeURIComponent(keep[k])); });
        S.cross = { n: n, href: url + (parts.length ? '#f=' + parts.join(';') : '') };
        if (S.N === 0 && n > 0) { pageCache.delete(1); if (!S.closed) placeSpread(spreadOf(S.p)); }
      });
    }

    /* ---------------- Mechanik ---------------- */
    var bwrap = $('.pc-b-wrap'), stage = $('.pc-b-stage'), leaf = $('.pc-b-leaf');
    var slotL = $('.pc-b-pg.is-l .pc-b-slot'), slotR = $('.pc-b-pg.is-r .pc-b-slot'), castL = $('.pc-b-pg.is-l .pc-b-cast'), castR = $('.pc-b-pg.is-r .pc-b-cast');
    var slotF = $('.pc-b-face.is-f .pc-b-slot'), slotB = $('.pc-b-face.is-b .pc-b-slot'), shadeF = $('.pc-b-face.is-f .pc-b-shade'), shadeB = $('.pc-b-face.is-b .pc-b-shade');
    var mqDesk = window.matchMedia('(min-width: 1024px)'), mqRM = window.matchMedia('(prefers-reduced-motion: reduce)');
    function desk() { return mqDesk.matches; }
    function reduced() { return mqRM.matches; }
    function put(slot, p) { var el = typeof p === 'number' ? pageEl(p) : p; if (slot.firstChild !== el || slot.childNodes.length !== 1) slot.replaceChildren(el); }
    function spreadOf(p) { return Math.floor(p / 2); }
    function placeSpread(k) { put(slotL, 2 * k); put(slotR, 2 * k + 1); }
    function setStageX(x) { stage.style.transform = desk() ? '' : 'translateX(' + x + 'px)'; }
    function viewX(p) { return desk() ? 0 : (p % 2 ? -S.W : 0); }
    function setLeaf(v) {
      leaf.style.transform = 'rotateY(' + (-180 * v) + 'deg)';
      var s = Math.sin(Math.PI * v);
      shadeF.style.opacity = (0.55 * s).toFixed(3); shadeB.style.opacity = (0.5 * s).toFixed(3);
      castR.style.opacity = v < 0.5 ? (0.7 * s).toFixed(3) : '0';
      castL.style.opacity = v > 0.5 ? (0.7 * s).toFixed(3) : '0';
    }
    function clearLeaf() { leaf.hidden = true; slotF.replaceChildren(); slotB.replaceChildren(); castL.style.opacity = castR.style.opacity = '0'; leaf.style.transform = ''; }
    /* Blatt vorwärts: Vorderseite (2k+1) dreht am Rücken nach links, ihre Rückseite (2m) liegt danach links */
    function opForward(k, m, pan) {
      put(slotL, 2 * k); put(slotF, 2 * k + 1); put(slotB, 2 * m); put(slotR, 2 * m + 1);
      leaf.hidden = false; setLeaf(0);
      return {
        set: function (v) { setLeaf(v); if (pan) setStageX(-S.W * (1 - v)); },
        end: function (ok) { if (ok) { put(slotL, 2 * m); S.p = desk() ? Math.max(1, 2 * m) : 2 * m; } else { put(slotR, 2 * k + 1); } clearLeaf(); setStageX(viewX(S.p)); }
      };
    }
    /* Blatt rückwärts: Rückseite (2k) dreht nach rechts, ihre Vorderseite (2m+1) liegt danach rechts */
    function opBackward(k, m, pan) {
      put(slotR, 2 * k + 1); put(slotB, 2 * k); put(slotF, 2 * m + 1); put(slotL, 2 * m);
      leaf.hidden = false; setLeaf(1);
      return {
        set: function (v) { setLeaf(1 - v); if (pan) setStageX(-S.W * v); },
        end: function (ok) { if (ok) { put(slotR, 2 * m + 1); S.p = desk() ? Math.max(1, 2 * m) : 2 * m + 1; } else { put(slotL, 2 * k); } clearLeaf(); setStageX(viewX(S.p)); }
      };
    }
    /* Handy: Blick wandert innerhalb der Doppelseite zur anderen Seite */
    function opPan(dir) {
      var k = spreadOf(S.p); placeSpread(k);
      return {
        set: function (v) { setStageX(dir > 0 ? -S.W * v : -S.W * (1 - v)); },
        end: function (ok) { if (ok) S.p = S.p + dir; setStageX(viewX(S.p)); }
      };
    }
    /* Cover öffnen: Aussenseite dreht weg, innen liegt das Inhaltsverzeichnis */
    function opCover() {
      put(slotL, pageEl(-99)); put(slotF, pageEl(-1)); put(slotB, 0); put(slotR, 1);
      leaf.hidden = false; setLeaf(0); bwrap.classList.add('is-closed');
      return {
        set: function (v) { setLeaf(v); bwrap.classList.toggle('is-closed', v < 0.5); },
        end: function () { bwrap.classList.remove('is-closed'); put(slotL, 0); clearLeaf(); S.closed = false; S.p = 1; setStageX(viewX(1)); }
      };
    }
    var easeOut = function (x) { return 1 - Math.pow(1 - x, 2.5); };
    var easeInOut = function (x) { return x < 0.5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2; };
    function animate(op, from, to, dur, done, ez) {
      if (S.anim) S.anim.finish();
      if (reduced()) { op.set(to); op.end(to === 1); S.anim = null; if (done) done(to === 1); return; }
      var E = ez || easeOut, raf = 0, over = false, t0 = performance.now();
      var A = { finish: function () { if (over) return; over = true; cancelAnimationFrame(raf); op.set(to); op.end(to === 1); if (S.anim === A) S.anim = null; if (done) done(to === 1); } };
      S.anim = A;
      var step = function (now) { if (over) return; var x = Math.min(1, (now - t0) / dur); op.set(from + (to - from) * E(x)); if (x < 1) raf = requestAnimationFrame(step); else A.finish(); };
      raf = requestAnimationFrame(step);
    }
    var DUR = 520, DUR_PAN = 300, DUR_JUMP = 560, DUR_COVER = 900;
    function canFwd() { if (S.closed) return true; return desk() ? 2 * spreadOf(S.p) + 2 <= S.N : S.p < S.N; }
    function canBack() { if (S.closed) return false; return desk() ? spreadOf(S.p) >= 1 : S.p > 0; }
    function opFor(dir) {
      if (S.closed) return dir > 0 ? opCover() : null;
      var p = S.p, k = spreadOf(p);
      if (dir > 0) { if (!canFwd()) return null; if (desk()) return opForward(k, k + 1, false); return p % 2 ? opForward(k, k + 1, true) : opPan(1); }
      if (!canBack()) return null;
      if (desk()) return opBackward(k, k - 1, false);
      return p % 2 ? opPan(-1) : opBackward(k, k - 1, true);
    }
    function turn(dir) {
      S.pick = null;
      if (S.anim) S.anim.finish();
      var op = opFor(dir);
      if (!op) { nudge(dir); return; }
      var pan = !desk() && !S.closed && !(S.p % 2 ? dir > 0 : dir < 0);
      animate(op, 0, 1, S.closed ? DUR_COVER : (pan ? DUR_PAN : DUR), function () { settle(false); }, S.closed ? easeInOut : easeOut);
    }
    function nudge(dir) { if (reduced() || !bwrap.animate) return; bwrap.animate([{ transform: 'translateX(0)' }, { transform: 'translateX(' + (dir * -7) + 'px)' }, { transform: 'translateX(0)' }], { duration: 220, easing: 'ease-out' }); }
    function goPage(q, opts) {
      opts = opts || {};
      S.pick = opts.pick || null;
      q = Math.max(desk() ? 1 : 0, Math.min(Math.max(1, S.N), q | 0));
      if (S.anim) S.anim.finish();
      if (S.closed) { S.closed = false; bwrap.classList.remove('is-closed'); clearLeaf(); }
      var k = spreadOf(S.p), m = spreadOf(q);
      if (desk() && !opts.instant && !reduced() && m !== k) {
        var op = m > k ? opForward(k, m, false) : opBackward(k, m, false);
        animate(op, 0, 1, Math.abs(m - k) === 1 ? DUR : DUR_JUMP, function () { S.p = q; settle(!opts.noHistory); });
        return;
      }
      S.p = q; placeSpread(spreadOf(q)); setStageX(viewX(q)); clearLeaf();
      if (!desk() && !opts.instant && !reduced() && stage.animate) stage.animate([{ opacity: 0.25 }, { opacity: 1 }], { duration: 220, easing: 'ease-out' });
      settle(!opts.noHistory && !opts.instant);
    }

    /* nach jeder Bewegung: Anzeige, Register, Adresse, Vorladen */
    function settle(push) {
      updateNav(); updateTabs(); prefetch(); pruneCache();
      writeHash('seite-' + Math.max(1, S.p), push);
      $('.pc-b-sr').textContent = t('liveP', { a: Math.max(1, S.p), n: Math.max(1, S.N) });
    }
    /* Nachbarseiten im Leerlauf vorbereiten (Bilder laden mit), nächste Seiten zuerst */
    var pfQueue = [], pfBusy = false;
    function prefetch() {
      var base = desk() ? 2 * spreadOf(S.p) : S.p;
      var order = desk() ? [0, 1, 2, 3, -1, -2, 4, 5] : [0, 1, 2, -1, -2, 3];
      pfQueue = order.map(function (d) { return base + d; }).filter(function (p) { return p >= 0 && p <= S.N + 1 && !pageCache.has(p); });
      if (!pfBusy) pump();
    }
    function pump() {
      if (!pfQueue.length) { pfBusy = false; return; }
      pfBusy = true;
      idle(function (dl) {
        do { var p = pfQueue.shift(); if (p !== undefined && p <= S.N + 1 && !pageCache.has(p)) pageEl(p); }
        while (pfQueue.length && dl && dl.timeRemaining() > 10);
        pump();
      });
    }
    function updateNav() {
      var N = Math.max(1, S.N), k = spreadOf(S.p), txt;
      if (desk()) {
        var a = 2 * k, b = 2 * k + 1;
        if (a === 0) txt = t('pageOf', { a: 1, n: N });
        else if (b > S.N) txt = t('pageOf', { a: a, n: N });
        else txt = t('pagesOf', { a: a, b: b, n: N });
      } else txt = S.p === 0 ? t('indexOf') : t('pageOf', { a: S.p, n: N });
      $('.pc-b-ptxt').textContent = txt;
      var f = canFwd() && S.N > 0, b2 = canBack();
      $$('.pc-b-a-next, .pc-b-m-next, .pc-b-edge.is-r').forEach(function (el) { el.disabled = !f; });
      $$('.pc-b-a-prev, .pc-b-m-prev, .pc-b-edge.is-l').forEach(function (el) { el.disabled = !b2; });
      var sc = $('.pc-b-scrub input'), ji = $('.pc-b-jump input');
      sc.max = N; sc.value = Math.max(1, S.p); ji.max = N; ji.placeholder = Math.max(1, S.p);
      var cur = curSet();
      $$('.pc-b-regrow button').forEach(function (bt) { bt.setAttribute('aria-current', String(cur === bt.dataset.code)); });
    }
    /* aktuelles Register = zuletzt angetipptes Set, solange es sichtbar ist, sonst das Set der ersten Karte auf der (linken) sichtbaren Seite */
    function curSet() {
      if (!S.starts.length || !S.N) return null;
      if (S.pick) {
        var st = S.starts.filter(function (x) { return x.code === S.pick; })[0];
        var vis = desk() ? [2 * spreadOf(S.p), 2 * spreadOf(S.p) + 1] : [S.p];
        if (st && vis.indexOf(st.page) >= 0) return S.pick;
      }
      var p = Math.min(S.N, desk() ? Math.max(1, 2 * spreadOf(S.p)) : Math.max(1, S.p));
      var pg = S.pages[p - 1];
      return pg && pg[0] ? pg[0].code : S.starts[0].code;
    }
    function tabColor(era) { return ERA_COLOR[era] || ERA_COLOR['']; }
    function renderTabs() {
      var L = $('.pc-b-tabs.is-l'), R = $('.pc-b-tabs.is-r');
      L.replaceChildren(); R.replaceChildren();
      S.starts.forEach(function (s) {
        ['l', 'r'].forEach(function (side) {
          var b = document.createElement('button');
          b.type = 'button'; b.className = 'pc-b-tab'; b.dataset.jump = s.page; b.dataset.code = s.code; b.dataset.side = side;
          b.style.background = tabColor(s.era); b.title = s.name + (s.code && s.code !== s.name ? ' (' + s.code + ')' : '');
          b.innerHTML = '<span>' + (s.code && s.code !== s.name ? '<b>' + esc(s.code) + '</b> ' : '') + esc(s.name) + (s.jp ? ' (JP)' : '') + '</span>';
          (side === 'l' ? L : R).appendChild(b);
        });
      });
      var rg = $('.pc-b-regrow');
      rg.replaceChildren();
      S.starts.forEach(function (s) {
        var b = document.createElement('button');
        b.type = 'button'; b.dataset.jump = s.page; b.dataset.code = s.code;
        b.innerHTML = '<i style="background:' + tabColor(s.era) + '"></i>' + esc(s.name) + (s.jp ? ' (JP)' : '') + (s.code && s.code !== s.name ? ' <small>' + esc(s.code) + '</small>' : '');
        rg.appendChild(b);
      });
      rg.hidden = S.starts.length < 2;
    }
    function updateTabs() {
      if (!desk()) return;
      var k = spreadOf(S.p), cur = curSet();
      $$('.pc-b-tab').forEach(function (b) {
        var page = +b.dataset.jump, leafNo = Math.ceil(page / 2), turned = leafNo <= k;
        var show = (b.dataset.side === 'l') === turned;
        b.classList.toggle('is-hid', !show || S.closed);
        b.tabIndex = show ? 0 : -1;
        b.setAttribute('aria-current', String(b.dataset.code === cur));
      });
    }

    /* ---------------- Grösse ---------------- */
    /* Kopfzeile klebt oben und wird beim Scrollen kleiner: für die Binderhöhe zählt die kleine Kopfzeile */
    function headerH() {
      var h = document.querySelector('.section-header');
      if (!h) return 0;
      var pos = getComputedStyle(h).position;
      if (pos !== 'sticky' && pos !== 'fixed') return 0;
      var hh = h.getBoundingClientRect().height;
      if (!h.classList.contains('scrolled-past-header')) {
        var logo = h.querySelector('.header__heading-logo-wrapper');
        if (logo) hh -= logo.getBoundingClientRect().height * 0.25;
      }
      return hh > window.innerHeight * 0.35 ? 0 : Math.max(0, hh);
    }
    function layout() {
      var zone = $('.pc-b-zone');
      var cs = getComputedStyle(zone);
      var cw = zone.clientWidth - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight);
      if (!cw) return;
      var vh = window.innerHeight, W, tabw = 150;
      if (desk()) {
        var room = cw - 2 * 66 - 24;
        var availH = vh - headerH() - 20;
        W = Math.min(560, (availH - 33) / 1.693);
        tabw = 176;
        if (2 * W + 2 * tabw > room) tabw = Math.max(96, Math.floor((room - 2 * W) / 2));
        if (2 * W + 2 * tabw > room) W = (room - 2 * tabw) / 2;
        W = Math.max(300, W);
      } else {
        W = Math.min(520, cw - 2 * 6);
      }
      W = Math.floor(W);
      var pad = Math.round(W * (desk() ? 0.042 : 0.03)), gap = Math.round(W * (desk() ? 0.026 : 0.022)), lh = Math.max(40, Math.round(W * 0.1));
      var pw = Math.floor((W - 2 * pad - 2 * gap) / 3), sh = Math.round(pw * 88 / 63);
      var H = 2 * pad + 3 * (sh + lh + 3) + 2 * gap + Math.round(W * 0.05);
      S.W = W; S.H = H; S.tabw = tabw;
      /* Slabs-Binder: 2 x 2 Hüllen im Slab-Format auf derselben Seitengrösse */
      var sgap = Math.round(W * 0.05);
      var sph = Math.floor((H - 2 * pad - Math.round(W * 0.05) - sgap - 2 * (lh + 3)) / 2), spw = Math.floor(sph * 0.62);
      var maxSpw = Math.floor((W - 2 * pad - sgap) / 2);
      if (spw > maxSpw) { spw = maxSpw; sph = Math.floor(spw / 0.62); }
      var r = root.style;
      r.setProperty('--W', W + 'px'); r.setProperty('--H', H + 'px'); r.setProperty('--pad', pad + 'px'); r.setProperty('--gap', gap + 'px');
      r.setProperty('--pw', pw + 'px'); r.setProperty('--sh', sh + 'px'); r.setProperty('--lh', lh + 'px'); r.setProperty('--bd', (desk() ? 12 : 6) + 'px');
      r.setProperty('--tabw', tabw + 'px'); r.setProperty('--spw', spw + 'px'); r.setProperty('--sph', sph + 'px'); r.setProperty('--sgap', sgap + 'px');
      $('.pc-b-scrub').style.width = Math.min(cw, desk() ? 2 * W : W) + 'px';
      setStageX(viewX(S.p));
    }

    /* ---------------- Ziehen und Wischen ---------------- */
    var drag = null, swallowClick = false;
    bwrap.addEventListener('pointerdown', function (e) {
      if (e.button !== 0 || e.target.closest('.pc-b-tab, .pc-b-edge, [data-jump], [data-reset], .pc-b-ebtn')) return;
      if (S.anim) S.anim.finish();
      var r = stage.getBoundingClientRect(), now = performance.now();
      drag = { x0: e.clientX, y0: e.clientY, id: e.pointerId, op: null, dir: 0, side: (e.clientX - r.left) < S.W ? 'l' : 'r', prog: 0, lastX: e.clientX, lastT: now, v: 0 };
    });
    bwrap.addEventListener('pointermove', function (e) {
      if (!drag || e.pointerId !== drag.id) return;
      var dx = e.clientX - drag.x0, dy = e.clientY - drag.y0;
      if (!drag.op) {
        if (Math.abs(dx) < 9 || Math.abs(dx) < Math.abs(dy) * 1.2) { if (Math.abs(dy) > 12) drag = null; return; }
        var dir = dx < 0 ? 1 : -1;
        if (desk() && !S.closed && ((dir > 0 && drag.side !== 'r') || (dir < 0 && drag.side !== 'l'))) { drag = null; return; }
        var op = opFor(dir);
        if (!op) { drag = null; nudge(dir); return; }
        drag.op = op; drag.dir = dir; swallowClick = true; S.pick = null;
        try { bwrap.setPointerCapture(e.pointerId); } catch (_) { /* ältere Browser */ }
      }
      var span = desk() ? S.W * 1.5 : S.W * 0.95;
      drag.prog = Math.max(0, Math.min(1, (drag.dir > 0 ? -dx : dx) / span));
      var now = performance.now();
      drag.v = (e.clientX - drag.lastX) / Math.max(1, now - drag.lastT); drag.lastX = e.clientX; drag.lastT = now;
      drag.op.set(drag.prog);
      e.preventDefault();
    });
    function endDrag(e) {
      if (!drag || (e && e.pointerId !== drag.id)) return;
      var d = drag; drag = null;
      if (!d.op) return;
      var fling = d.dir > 0 ? d.v < -0.45 : d.v > 0.45;
      var ok = d.prog > 0.32 || fling;
      var rest = ok ? 1 - d.prog : d.prog;
      animate(d.op, d.prog, ok ? 1 : 0, Math.max(140, rest * DUR), function (done) { if (done) settle(false); else updateNav(); });
      setTimeout(function () { swallowClick = false; }, 60);
    }
    bwrap.addEventListener('pointerup', endDrag);
    bwrap.addEventListener('pointercancel', endDrag);
    bwrap.addEventListener('click', function (e) {
      if (swallowClick) { e.preventDefault(); e.stopPropagation(); swallowClick = false; return; }
      var j = e.target.closest('[data-jump]');
      if (j) { e.preventDefault(); goPage(+j.dataset.jump, { pick: j.dataset.code }); return; }
      if (e.target.closest('[data-reset]')) { e.preventDefault(); resetFilters(); return; }
      var a = e.target.closest('a.pc-b-pocket');
      if (a && !(e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1)) { e.preventDefault(); openLV(+a.dataset.i); }
    }, true);
    bwrap.addEventListener('dragstart', function (e) { e.preventDefault(); });

    /* Knöpfe, Tastatur */
    $$('.pc-b-a-next, .pc-b-m-next, .pc-b-edge.is-r').forEach(function (el) { el.addEventListener('click', function () { turn(1); }); });
    $$('.pc-b-a-prev, .pc-b-m-prev, .pc-b-edge.is-l').forEach(function (el) { el.addEventListener('click', function () { turn(-1); }); });
    function inView() { var r = bwrap.getBoundingClientRect(); return r.bottom > 60 && r.top < window.innerHeight - 60; }
    function otherLayerOpen() {
      return !!document.querySelector('header-drawer details[open], details-modal details[open], .menu-drawer-container[open], cart-drawer.active, #cart-notification.active, .header__inline-menu details[open]');
    }
    document.addEventListener('keydown', function (e) {
      if (!root.isConnected) return;
      if (!lv.hidden) { if (e.key === 'Escape') closeLV(); else if (e.key === 'ArrowRight') lvStep(1); else if (e.key === 'ArrowLeft') lvStep(-1); else if (e.key === 'Tab') trapFocus(e); return; }
      if (filtersEl.classList.contains('is-open') && e.key === 'Escape') { closeSheet(); return; }
      if (e.altKey || e.ctrlKey || e.metaKey || e.defaultPrevented) return;
      var tag = (document.activeElement && document.activeElement.tagName) || '';
      if (/INPUT|SELECT|TEXTAREA/.test(tag) || (document.activeElement && document.activeElement.isContentEditable)) return;
      if (!inView() || otherLayerOpen()) return;
      if (e.key === 'ArrowRight' || e.key === 'PageDown') { e.preventDefault(); turn(1); }
      else if (e.key === 'ArrowLeft' || e.key === 'PageUp') { e.preventDefault(); turn(-1); }
      else if (e.key === 'Home' && root.contains(document.activeElement)) { e.preventDefault(); goPage(desk() ? 1 : 0); }
      else if (e.key === 'End' && root.contains(document.activeElement)) { e.preventDefault(); goPage(S.N); }
    });
    $('.pc-b-regrow').addEventListener('click', function (e) { var b = e.target.closest('[data-jump]'); if (b) goPage(+b.dataset.jump, { pick: b.dataset.code }); });
    $('.pc-b-jump').addEventListener('submit', function (e) { e.preventDefault(); var inp = $('.pc-b-jump input'), v = parseInt(inp.value, 10); if (v) goPage(v); inp.value = ''; });
    var scrubIn = $('.pc-b-scrub input'), scrub = $('.pc-b-scrub');
    function scrubLabel() {
      var v = +scrubIn.value, max = +scrubIn.max || 1, o = $('.pc-b-scrub output'), set = '';
      S.starts.forEach(function (s) { if (s.page <= v) set = ' · ' + s.name; });
      o.textContent = t('pageOf', { a: v, n: max }) + set;
      o.style.left = ((v - 1) / Math.max(1, max - 1) * 100) + '%';
    }
    scrubIn.addEventListener('input', function () { scrub.classList.add('is-show'); scrubLabel(); });
    scrubIn.addEventListener('change', function () { scrub.classList.remove('is-show'); goPage(+scrubIn.value); });
    scrubIn.addEventListener('blur', function () { scrub.classList.remove('is-show'); });
    function renderScrubBar() {
      var bar = $('.pc-b-bar'), N = Math.max(1, S.N);
      bar.replaceChildren();
      S.starts.forEach(function (s, i) {
        var end = i + 1 < S.starts.length ? S.starts[i + 1].page : N + 1, sp = document.createElement('span');
        sp.style.flex = String(Math.max(0.3, end - s.page)); sp.style.background = tabColor(s.era); sp.style.opacity = i % 2 ? '.75' : '1';
        bar.appendChild(sp);
      });
    }

    /* ---------------- Filter ---------------- */
    var filtersEl = $('.pc-b-filters');
    function opt(v, label, sel) { return '<option value="' + esc(v) + '"' + (sel ? ' selected' : '') + '>' + esc(label) + '</option>'; }
    function facet(key) { return S.all.filter(function (c) { return matches(c, S.f, key); }); }
    function renderFilters() {
      var f = S.f, sel = function (k) { return $('select[data-f="' + k + '"]'); };
      /* In allen Filtern nur Werte, die im Binder gerade vorkommen (mit den übrigen Filtern), die gewählte Auswahl bleibt immer stehen */
      var pe = facet('era');
      sel('era').innerHTML = opt('', t('all')) + AREAS.filter(function (a) { return a !== '' && (f.era === a || pe.some(function (c) { return c.area === a; })); })
        .map(function (a) { return opt(a, areaLabel(a), f.era === a); }).join('');
      var ps = facet('set'), sets = {}, setList = [];
      ps.forEach(function (c) { if (c.code && !sets[c.code]) { sets[c.code] = c; setList.push(c); } });
      if (f.set && !sets[f.set]) { var sc = S.all.filter(function (c) { return c.code === f.set; })[0]; if (sc) setList.push(sc); }
      setList.sort(function (a, b) { return (b.setDate || '').localeCompare(a.setDate || '') || a.code.localeCompare(b.code); });
      sel('set').innerHTML = opt('', t('all')) + setList.map(function (c) {
        return opt(c.code, c.setName + (c.jp ? ' (JP)' : '') + (c.code && c.code !== c.setName ? ' · ' + c.code : ''), f.set === c.code);
      }).join('');
      var pl = facet('lang');
      sel('lang').innerHTML = opt('', t('all')) + LANGS.filter(function (l) { return f.lang === l || pl.some(function (c) { return c.lang === l; }); })
        .map(function (l) { return opt(l, t(l), f.lang === l); }).join('');
      var rarSel = sel('rar');
      if (MODE === 'slabs') {
        var pg = facet('grader');
        rarSel.dataset.key = 'grader';
        rarSel.innerHTML = opt('', t('all')) + GRADERS.filter(function (g) { return f.grader === g || pg.some(function (c) { return c.grader === g; }); })
          .map(function (g) { return opt(g, g, f.grader === g); }).join('');
      } else {
        var pr = facet('rar'), extra = [];
        pr.forEach(function (c) { if (c.rarity && RAR_ORDER.indexOf(c.rarity) < 0 && extra.indexOf(c.rarity) < 0) extra.push(c.rarity); });
        rarSel.dataset.key = 'rar';
        rarSel.innerHTML = opt('', t('all')) + RAR_ORDER.concat(extra).filter(function (r) { return f.rar === r || pr.some(function (c) { return c.rarity === r; }); })
          .map(function (r) { return opt(r, r, f.rar === r); }).join('');
      }
      var pp = facet('price'), plab = function (r) { return r[0] === 0 ? t('pUpTo', { b: r[1] }) : r[1] >= 1e9 ? t('pFrom', { a: r[0] }) : t('pRange', { a: r[0], b: r[1] }); };
      sel('price').innerHTML = opt('', t('all')) + PRICE[MODE].map(function (r, i) { return { r: r, v: 'p' + (i + 1) }; })
        .filter(function (o) { return f.price === o.v || pp.some(function (c) { return c.price > o.r[0] && c.price <= o.r[1]; }); })
        .map(function (o) { return opt(o.v, plab(o.r), f.price === o.v); }).join('');
      sel('sort').innerHTML = [['set-new', 'sSetNew'], ['set-old', 'sSetOld'], ['new', 'sNew'], ['pa', 'sPa'], ['pd', 'sPd'], ['name', 'sName']]
        .map(function (o) { return opt(o[0], t(o[1]), f.sort === o[0]); }).join('');
      ['era', 'set', 'lang', 'rar', 'price'].forEach(function (k) { sel(k).classList.toggle('is-set', !!sel(k).value); });
      var active = activeCount();
      $('.pc-b-reset').disabled = !active;
      var bi = $('.pc-b-fbtn i'); bi.hidden = !active; bi.textContent = active;
      $('.pc-b-clr').hidden = !f.q;
    }
    function onFilter() {
      recompute(); renderFilters(); renderTabs(); renderScrubBar(); updateCount();
      S.closed = false; bwrap.classList.remove('is-closed');
      goPage(1, { instant: true });
      if (!S.N) loadCross();
    }
    function updateCount() {
      var n = S.list.length, p = Math.max(1, S.N);
      $('.pc-b-count').textContent = nounCount(n) + ' · ' + (p === 1 ? t('pages1') : t('pages', { n: p })) + (S.loading ? ' · ' + t('loading') : '');
    }
    function resetFilters() { S.f = defF(); $('.pc-b-q').value = ''; onFilter(); }
    $$('.pc-b-filters select').forEach(function (s) {
      s.addEventListener('change', function (e) {
        var k = s.dataset.f === 'rar' ? (s.dataset.key || 'rar') : s.dataset.f;
        S.f[k] = e.target.value;
        if (k === 'era') S.f.set = '';
        onFilter();
      });
    });
    var qT = 0, qIn = $('.pc-b-q');
    qIn.addEventListener('input', function () { clearTimeout(qT); qT = setTimeout(function () { S.f.q = qIn.value; onFilter(); }, 160); });
    qIn.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); qIn.blur(); } });
    $('.pc-b-clr').addEventListener('click', function () { qIn.value = ''; S.f.q = ''; onFilter(); qIn.focus(); });
    $('.pc-b-reset').addEventListener('click', resetFilters);
    function openSheet() {
      filtersEl.classList.add('is-open');
      var s = document.createElement('div'); s.className = 'pc-b-scrim'; s.addEventListener('click', closeSheet); root.appendChild(s);
      $('.pc-b-done').hidden = false; var first = filtersEl.querySelector('select'); if (first) first.focus();
    }
    function closeSheet() { filtersEl.classList.remove('is-open'); var s = $('.pc-b-scrim'); if (s) s.remove(); $('.pc-b-done').hidden = true; $('.pc-b-fbtn').focus(); }
    $('.pc-b-fbtn').addEventListener('click', openSheet);
    $('.pc-b-sheet-x').addEventListener('click', closeSheet);
    $('.pc-b-done').addEventListener('click', closeSheet);

    /* ---------------- Kartenverzeichnis (nach Set geordnet) ---------------- */
    function renderList() {
      var L = sortList(S.all.slice(), 'set-new'), by = [], idx = {};
      L.forEach(function (c) {
        var key = c.setName + (c.code && c.code !== c.setName ? ' (' + c.code + ')' : '') + (c.jp ? ' JP' : '');
        if (idx[key] == null) { idx[key] = by.length; by.push({ k: key, arr: [] }); }
        by[idx[key]].arr.push(c);
      });
      var h = '';
      by.forEach(function (g) {
        h += '<h4>' + esc(g.k) + '</h4><ul>' + g.arr.map(function (c) {
          return '<li><a href="' + esc(c.url) + '">' + esc(c.name) + '</a> <span>' + esc(numTxt(c)) + ' · ' + (c.kind !== 'raw' ? esc(c.grade) + ' · ' : '') + esc(c.lang) + ' · ' + fmtPrice(c.price) + '</span></li>';
        }).join('') + '</ul>';
      });
      if (h) $('.pc-b-cols').innerHTML = h;
    }

    /* ---------------- Grossansicht ---------------- */
    var lv = $('.pc-b-lv'), lvImg = $('.pc-b-lv-img'), zoomBox = $('.pc-b-zoom'), lastFocus = null, zoomed = false;
    function openLV(i) {
      S.lvIndex = i; S.lvSide = 'front'; lastFocus = document.activeElement;
      lv.hidden = false; document.documentElement.style.overflow = 'hidden';
      fillLV(); $('.pc-b-lv-x').focus();
    }
    function closeLV() { lv.hidden = true; document.documentElement.style.overflow = ''; setZoom(false); if (lastFocus && lastFocus.focus) lastFocus.focus(); }
    function lvStep(d) { var n = S.lvIndex + d; if (n < 0 || n >= S.list.length) return; S.lvIndex = n; S.lvSide = 'front'; fillLV(); }
    function fillLV() {
      var c = S.list[S.lvIndex];
      if (!c) return;
      setZoom(false);
      var useBack = S.lvSide === 'back' && !!c.B;
      var src = useBack ? c.B : c.F;
      lvImg.onerror = function () { lvImg.onerror = null; lvImg.src = placeholder(useBack); };
      lvImg.src = src || placeholder(useBack);
      lvImg.alt = c.name + ' ' + numTxt(c) + ', ' + (useBack ? t('back') : t('front'));
      var sf = $('.pc-b-s-front'), sb = $('.pc-b-s-back');
      sf.textContent = t('front'); sb.textContent = t('back');
      sf.setAttribute('aria-pressed', String(!useBack)); sb.setAttribute('aria-pressed', String(useBack));
      $('.pc-b-sides').hidden = !c.B;
      $('.pc-b-zhint').textContent = t('zin');
      $('.pc-b-lveye').textContent = areaLabel(c.area) + (c.era && c.era !== c.area && c.area !== '' ? ' · ' + c.era : '');
      $('.pc-b-lvtitle').textContent = c.name;
      var rows = [];
      if (c.setName) rows.push([t('setL'), c.setName + (c.code && c.code !== c.setName ? ' (' + c.code + ')' : '')]);
      rows.push([t('num'), numTxt(c)]);
      if (c.rarity) rows.push([t('rarity'), c.rarity]);
      if (c.lang) rows.push([t('lng'), t(c.lang)]);
      if (c.kind === 'raw' && c.cond) rows.push([t('cond'), c.cond]);
      if (c.kind !== 'raw' && c.grade) rows.push([t('grade'), c.grade]);
      var dl = rows.map(function (r) { return '<dt>' + esc(r[0]) + '</dt><dd>' + esc(r[1]) + '</dd>'; }).join('');
      if (c.cert) dl += '<dt>' + esc(t('cert')) + '</dt><dd>' + esc(c.cert) + (c.grader === 'PSA' ? ' · <a href="https://www.psacard.com/cert/' + encodeURIComponent(c.cert) + '" target="_blank" rel="noopener">' + esc(t('certChk')) + '</a>' : '') + '</dd>';
      $('.pc-b-dl').innerHTML = dl;
      $('.pc-b-price').textContent = fmtPrice(c.price);
      var cb = $('.pc-b-lv-cart'), note = $('.pc-b-lv-note'), notes = [];
      note.classList.remove('is-err');
      if (c.buy && c.vid) {
        cb.hidden = false;
        var inCart = !!S.cart[c.vid];
        cb.textContent = inCart ? t('inCart') + ' ✓' : t('cart'); cb.disabled = inCart;
      } else {
        cb.hidden = true;
        notes.push(t('noBuy'));
      }
      if (!src) notes.push(useBack ? t('phBack') : t('phNote'));
      note.textContent = notes.join(' '); note.hidden = !notes.length;
      var ln = $('.pc-b-lv-link'); ln.textContent = t('product'); ln.href = c.url;
      var lp = $('.pc-b-lv-prev'), lnx = $('.pc-b-lv-next');
      lp.textContent = '‹ ' + t('prevC'); lnx.textContent = t('nextC') + ' ›';
      lp.disabled = S.lvIndex <= 0; lnx.disabled = S.lvIndex >= S.list.length - 1;
    }
    $('.pc-b-s-front').addEventListener('click', function () { S.lvSide = 'front'; fillLV(); });
    $('.pc-b-s-back').addEventListener('click', function () { S.lvSide = 'back'; fillLV(); });
    $('.pc-b-lv-prev').addEventListener('click', function () { lvStep(-1); });
    $('.pc-b-lv-next').addEventListener('click', function () { lvStep(1); });
    $$('.pc-b-lv [data-close]').forEach(function (el) { el.addEventListener('click', closeLV); });
    function setZoom(on, e) {
      zoomed = on; zoomBox.classList.toggle('is-on', on);
      if (on && e) origin(e);
      lvImg.style.transform = on ? 'scale(2.4)' : '';
      $('.pc-b-zhint').textContent = on ? t('zout') : t('zin');
    }
    function origin(e) {
      var r = zoomBox.getBoundingClientRect();
      var x = Math.max(0, Math.min(1, (e.clientX - r.left) / r.width)), y = Math.max(0, Math.min(1, (e.clientY - r.top) / r.height));
      lvImg.style.transformOrigin = (x * 100) + '% ' + (y * 100) + '%';
    }
    var zDown = null;
    zoomBox.addEventListener('pointerdown', function (e) { zDown = { x: e.clientX, y: e.clientY }; if (zoomed) { try { zoomBox.setPointerCapture(e.pointerId); } catch (_) { /* egal */ } } });
    zoomBox.addEventListener('pointermove', function (e) { if (zoomed && (e.pointerType === 'mouse' || zDown)) origin(e); });
    zoomBox.addEventListener('pointerup', function (e) { var moved = zDown && Math.hypot(e.clientX - zDown.x, e.clientY - zDown.y) > 8; zDown = null; if (!moved) setZoom(!zoomed, e); });
    function trapFocus(e) {
      var f = Array.prototype.slice.call(lv.querySelectorAll('button:not([disabled]), a[href]')).filter(function (el) { return el.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
    var toastT = 0;
    function toast(msg) { var el = $('.pc-b-toast'); el.textContent = msg; el.classList.add('is-on'); clearTimeout(toastT); toastT = setTimeout(function () { el.classList.remove('is-on'); }, 2600); }

    /* Warenkorb: gleicher Weg wie der Knopf auf der Produktseite (Dawn), danach öffnet sich der Warenkorb-Hinweis */
    function addToCart(c) {
      var cb = $('.pc-b-lv-cart'), note = $('.pc-b-lv-note');
      cb.disabled = true; cb.textContent = t('adding');
      var cartEl = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      var fd = new FormData();
      fd.append('id', c.vid); fd.append('quantity', '1');
      if (cartEl && cartEl.getSectionsToRender) {
        fd.append('sections', cartEl.getSectionsToRender().map(function (s) { return s.id; }));
        fd.append('sections_url', window.location.pathname);
      }
      var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';
      fetch(addUrl, { method: 'POST', headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' }, body: fd })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.status) {
            cb.disabled = false; cb.textContent = t('cart');
            note.textContent = (res.description || res.message || t('cartErr')); note.classList.add('is-err'); note.hidden = false;
            return;
          }
          S.cart[c.vid] = true;
          if (typeof window.publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            try { window.publish(PUB_SUB_EVENTS.cartUpdate, { source: 'pc-binder', productVariantId: String(c.vid), cartData: res }); } catch (_) { /* egal */ }
          }
          closeLV();
          if (cartEl && cartEl.renderContents && res.sections) {
            try { if (cartEl.setActiveElement) cartEl.setActiveElement(document.activeElement); cartEl.renderContents(res); }
            catch (err) { toast(t('toast', { name: c.name })); }
          } else {
            toast(t('toast', { name: c.name }));
          }
        })
        .catch(function () { cb.disabled = false; cb.textContent = t('cart'); note.textContent = t('cartErr'); note.classList.add('is-err'); note.hidden = false; });
    }
    $('.pc-b-lv-cart').addEventListener('click', function () { var c = S.list[S.lvIndex]; if (c && c.buy && !S.cart[c.vid]) addToCart(c); });
    /* Was schon im Warenkorb liegt, zeigt der Knopf gleich als «Im Warenkorb» */
    function readCart() {
      var root2 = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(root2 + 'cart.js', { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.json() : null; })
        .then(function (cart) { if (cart && cart.items) cart.items.forEach(function (it) { S.cart[it.variant_id] = true; }); }).catch(function () { /* egal */ });
    }

    /* ---------------- Adresse ---------------- */
    function writeHash(name, push) {
      if (location.hash === '#' + name) return;
      try { if (push) history.pushState(null, '', '#' + name); else history.replaceState(null, '', '#' + name); }
      catch (_) { /* egal */ }
    }
    function readHash() {
      var h = decodeURIComponent(location.hash.slice(1));
      var m = h.match(/^(?:seite|page|slabs)-(\d+)$/);
      if (m) return { page: +m[1] };
      if (h.indexOf('f=') === 0) {
        var f = {};
        h.slice(2).split(';').forEach(function (part) { var i = part.indexOf(':'); if (i > 0) f[part.slice(0, i)] = decodeURIComponent(part.slice(i + 1)); });
        return { page: 1, f: f };
      }
      return null;
    }
    window.addEventListener('popstate', function () {
      var r = readHash();
      if (r && r.page && r.page !== Math.max(1, S.p)) goPage(r.page, { noHistory: true });
    });

    /* ---------------- Texte ---------------- */
    function applyTexts() {
      qIn.placeholder = t('search'); qIn.setAttribute('aria-label', t('search'));
      $('.pc-b-clr').setAttribute('aria-label', t('clear'));
      $$('[data-l]').forEach(function (l) { var k = l.dataset.l; l.textContent = t(k === 'rar' && MODE === 'slabs' ? 'grader' : k); });
      $$('.pc-b-fsel').forEach(function (box) { var l = box.querySelector('label'), s = box.querySelector('select'); var id = root.id + '-' + s.dataset.f; s.id = id; l.htmlFor = id; });
      $('.pc-b-reset').textContent = t('reset'); $('.pc-b-fbtn-txt').textContent = t('filters'); $('.pc-b-sheet-title').textContent = t('filtersT'); $('.pc-b-done').textContent = t('done');
      $('.pc-b-sheet-x').setAttribute('aria-label', t('close')); $('.pc-b-lv-x').setAttribute('aria-label', t('close'));
      $$('.pc-b-a-prev, .pc-b-m-prev, .pc-b-edge.is-l').forEach(function (el) { el.setAttribute('aria-label', t('prev')); });
      $$('.pc-b-a-next, .pc-b-m-next, .pc-b-edge.is-r').forEach(function (el) { el.setAttribute('aria-label', t('next')); });
      $('.pc-b-jump label').textContent = t('jump'); $('.pc-b-jump button').textContent = t('go');
      var ji = $('.pc-b-jump input'); ji.id = root.id + '-jump'; $('.pc-b-jump label').htmlFor = ji.id;
      scrubIn.setAttribute('aria-label', t('jump'));
      bwrap.setAttribute('aria-label', t('region')); $('.pc-b-regrow').setAttribute('aria-label', t('registers'));
      var lvt = $('.pc-b-lvtitle'); lvt.id = root.id + '-lvt'; lv.setAttribute('aria-labelledby', lvt.id);
    }

    function startClosed() {
      if (S.anim) S.anim.finish();
      S.closed = true; S.p = 1;
      put(slotL, pageEl(-99)); put(slotR, 1); put(slotF, pageEl(-1)); put(slotB, 0);
      leaf.hidden = false; setLeaf(0); bwrap.classList.add('is-closed'); setStageX(viewX(1)); updateNav(); updateTabs();
    }
    var rT = 0, wasDesk = desk();
    window.addEventListener('resize', function () {
      clearTimeout(rT);
      rT = setTimeout(function () {
        if (!root.isConnected) return;
        if (S.anim) S.anim.finish();
        var d = desk(), w0 = S.W;
        layout();
        if (S.W !== w0 && !S.closed) { pageCache.clear(); placeSpread(spreadOf(S.p)); prefetch(); }
        if (d !== wasDesk) {
          wasDesk = d;
          if (S.closed) { S.closed = false; bwrap.classList.remove('is-closed'); clearLeaf(); }
          if (d) S.p = Math.max(1, S.p);
          placeSpread(spreadOf(S.p)); setStageX(viewX(S.p)); updateNav(); updateTabs();
        }
      }, 120);
    });

    /* ---------------- Start ---------------- */
    (function init() {
      applyTexts();
      var first = null;
      try { first = JSON.parse(($('script.pc-b-data') || {}).textContent || 'null'); } catch (e) { first = null; }
      if (first && first.items) addItems(first.items);
      var h = readHash();
      if (h && h.f) {
        Object.keys(h.f).forEach(function (k) { if (k in S.f) S.f[k] = h.f[k]; });
        qIn.value = S.f.q || '';
      }
      recompute(); renderFilters(); renderTabs(); renderScrubBar(); renderList(); updateCount();
      layout();
      var deep = h && h.page > 1 && h.page <= S.N;
      var seen = false;
      try { seen = sessionStorage.getItem('pc-binder-cover') === '1'; sessionStorage.setItem('pc-binder-cover', '1'); } catch (_) { seen = true; }
      if (deep) goPage(h.page, { instant: true, noHistory: true });
      else if (!reduced() && !seen && S.N > 0) { startClosed(); setTimeout(function () { if (S.closed) turn(1); }, 450); }
      else goPage(1, { instant: true, noHistory: true });
      if (!S.N) loadCross();
      readCart();
      /* weitere Pakete (ab 250 Karten) nachladen, die aktuelle Seite bleibt stehen */
      if (first && first.pages > 1) {
        S.loading = true; updateCount();
        var todo = [];
        for (var n = 1; n <= first.pages; n++) if (n !== first.page) todo.push(n);
        Promise.all(todo.map(function (n) { return fetchData(root.dataset.url, n); })).then(function (res) {
          res.forEach(function (d) { if (d && d.items) addItems(d.items); });
          S.loading = false;
          var keep = S.p, wasClosed = S.closed;
          recompute(); renderFilters(); renderTabs(); renderScrubBar(); renderList(); updateCount();
          if (!wasClosed) goPage(keep, { instant: true, noHistory: true });
        });
      }
    })();
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('.pc-binder').forEach(function (el) {
      if (el.dataset.pcbInit) return;
      el.dataset.pcbInit = '1';
      try { create(el); } catch (err) { if (window.console) console.error('Pokécado Binder:', err); }
    });
  }
  window.PcBinder = { initAll: initAll };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
